<div class="mb-6">
  @if(filtriForm){
    <form [formGroup]="filtriForm">
      <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5 gap-3">
        <div class="p-input-icon-left p-input-icon-right p-float-label">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            id="cercaIscritto"
            formControlName="inserimento"
            class="shadow-4" />
          <label for="cercaIscritto">Cerca Iscritto</label>
          <i class="pi pi-times pr-1 cursor-pointer" id="clearIcon" (click)="resetBoxRicerca()"></i>
        </div>
        <p-button
          label="Filtri Avanzati"
          icon="pi pi-filter"
          iconPos="right"
          class="filtriAvanzatiBtn mb-3 sm:mb-0 shadow-4"
          [badge]="numeroFiltriAvanzati.toString()"
          (click)="showFilters()" />
        <p-button
          label="Gestici Colonne"
          icon="pi pi-filter"
          iconPos="right"
          class="filtriAvanzatiBtn mb-3 sm:mb-0 shadow-4"
          (click)="showColumn()" />
        <p-button
          class="clearFiltri"
          size="small"
          [outlined]="true"
          icon="pi pi-filter-slash"
          (click)="clearFilters()"
          pTooltip="Pulisci Filtri"
          tooltipPosition="right" />
        <div class="flex bottoniStyle">
          @if(xlsSpinner){
            <div class="pt-2">
              <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
            </div>
          }
          @else{
            <p-button
              type="button"
              icon="pi pi-table"
              iconPos="right"
              (click)="printIscrittiXLS()"
              pTooltip="Genera XLS"
              tooltipPosition="bottom"
              [disabled]="!role_service.isAlboOrConsultazione()" />
          }
        </div>
      </div>
      @if(showAdvancedFilters){
        <div class="flex flex-column w-full gap-1 border-round shadow-4 mb-5 p-3">
          <!-- FILTRI GESTIONE ALBO -->
          <p class="font-semibold text-500 border-300 border-bottom-2 w-8">Info Albo</p>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Stato</p>
            <p-multiSelect
              [options]="statiIscrittoDropdown"
              formControlName="stato"
              optionLabel="nome"
              optionValue="id"
              filter="false"
              showClear="true"
              placeholder="--"
              class="w-6 noFilter" />
            <p-dropdown
              formControlName="statoOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Sezione</p>
            <p-dropdown
              formControlName="sezione"
              [showClear]="true"
              [options]="sezioniDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="sezioneOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Titolo</p>
            <p-multiSelect
              [options]="titoliDropdown"
              formControlName="titoli"
              optionLabel="nome"
              optionValue="id"
              filter="false"
              showClear="true"
              placeholder="--"
              class="w-6 noFilter" />
            <p-dropdown
              formControlName="titoliOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Provincia Residenza</p>
            <p-multiSelect
              [options]="provinceDropdown"
              formControlName="residenzaProvincia"
              optionLabel="nome"
              optionValue="codice"
              filter="true"
              showClear="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="residenzaProvinciaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Comune Residenza</p>
            <p-autoComplete
              appendTo="body"
              formControlName="residenzaComune"
              [suggestions]="filteredComuni"
              (completeMethod)="filterAutoComplete($event, 'comuni')"
              field="nome"
              [minLength]="3"
              [showClear]="true"
              placeholder="--"
              class="w-6">
              <ng-template let-comune pTemplate="item">
                <div class="flex align-items-center w-8 gap-4 gap-2">
                  <div>{{ comune.nome }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <p-dropdown
              formControlName="residenzaComuneOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Provincia Domicilio</p>
            <p-multiSelect
              [options]="provinceDropdown"
              formControlName="domicilioProvincia"
              optionLabel="nome"
              optionValue="codice"
              filter="true"
              showClear="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="domicilioProvinciaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Comune Domicilio</p>
            <p-autoComplete
              appendTo="body"
              formControlName="domicilioComune"
              [suggestions]="filteredComuni"
              (completeMethod)="filterAutoComplete($event, 'comuni')"
              field="nome"
              [minLength]="3"
              [showClear]="true"
              placeholder="--"
              class="w-6">
              <ng-template let-comune pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <div>{{ comune.nome }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
            <p-dropdown
              formControlName="domicilioComuneOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Anno Nascita</p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-inputNumber
                  inputId="annoNascitaDal"
                  [useGrouping]="false"
                  formControlName="annoNascitaDal"
                  [minlength]="4"
                  [maxlength]="4" 
                  placeholder="dal"
                  [showClear]="true" />
              </div>
              <div class="w-6">
                <p-inputNumber
                  inputId="annoNascitaAl"
                  [useGrouping]="false"
                  formControlName="annoNascitaAl"
                  [minlength]="4"
                  [maxlength]="4"
                  placeholder="al"
                  [showClear]="true" />
              </div>
            </div>
            <p-dropdown
              formControlName="annoNascitaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Data Iscrizione</p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-calendar
                  formControlName="dataIscrizioneDal"
                  dateFormat="dd/mm/yy"
                  inputId="dataIscrizioneDal"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  placeholder="dal"
                  [showClear]="true" />
              </div>
              <div class="w-6">
                <p-calendar
                  formControlName="dataIscrizioneAl"
                  dateFormat="dd/mm/yy"
                  inputId="dataIscrizioneAl"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  placeholder="al"
                  [showClear]="true"></p-calendar>
              </div>
            </div>
            <p-dropdown
              formControlName="dataIscrizioneOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Senza Pec</p>
            <p-checkbox
              formControlName="noPec"
              [binary]="true"
              class="w-6" />
            <p-dropdown
              formControlName="noPecOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Permesso di Soggiorno</p>
            <p-checkbox
              formControlName="permessoSoggiorno"
              [binary]="true"
              class="w-6" />
            <p-dropdown
              formControlName="permessoSoggiornoOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">C.T.U.</p>
            <p-multiSelect
              [options]="ctuDropdown"
              formControlName="ctu"
              optionLabel="nome"
              optionValue="id"
              filter="true"
              showClear="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="ctuOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Perito</p>
            <p-multiSelect
              [options]="ctuDropdown"
              formControlName="perito"
              optionLabel="nome"
              optionValue="id"
              filter="true"
              showClear="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="peritoOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <!-- FILTRI CONTABILITÀ -->
          <p class="font-semibold text-500 border-300 border-bottom-2 w-8">Contabilità</p>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Situazione</p>
            <p-multiSelect
              [options]="situazioniDropdown"
              formControlName="situazione"
              optionLabel="nome"
              optionValue="valore"
              filter="false"
              showClear="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="situazioneOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Anno Morosità</p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-inputNumber
                  inputId="annoMorositaDal"
                  [useGrouping]="false"
                  formControlName="annoMorositaDal"
                  [minlength]="4"
                  [maxlength]="4" 
                  placeholder="dal"
                  [showClear]="true" />
              </div>
              <div class="w-6">
                <p-inputNumber
                  inputId="annoMorositaAl"
                  [useGrouping]="false"
                  formControlName="annoMorositaAl"
                  [minlength]="4"
                  [maxlength]="4"
                  placeholder="al"
                  [showClear]="true" />
              </div>
            </div>
            <p-dropdown
              formControlName="annoMorositaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">N° Anni Morosità</p>
            <div class="flex align-items-center justify-content-between w-6 gap-3">
              <div class="w-6">
                <p-inputNumber
                  inputId="numeroAnniMorositaDal"
                  [useGrouping]="false"
                  formControlName="numeroAnniMorositaDal"
                  [minlength]="4"
                  [maxlength]="4" 
                  placeholder="dal"
                  [showClear]="true" />
              </div>
              <div class="w-6">
                <p-inputNumber
                  inputId="numeroAnniMorositaAl"
                  [useGrouping]="false"
                  formControlName="numeroAnniMorositaAl"
                  [minlength]="4"
                  [maxlength]="4"
                  placeholder="al"
                  [showClear]="true" />
              </div>
            </div>
            <p-dropdown
              formControlName="numeroAnniMorositaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <!-- DELIBERE -->
          <!-- <p class="font-semibold text-500 border-300 border-bottom-2 w-8">Delibere</p>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Numero Delibera</p>
            <p-inputNumber
              inputId="numeroDelibera"
              [useGrouping]="false"
              formControlName="numeroDelibera"
              [showClear]="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="numeroDeliberaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Tipo Delibera</p>
            <p-dropdown
              formControlName="tipoDelibera"
              [showClear]="true"
              [options]="tipoDeliberaDropdown"
              optionLabel="nome"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="tipoDeliberaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Delibera Chiusa</p>
            <p-checkbox
              formControlName="chiusa"
              [binary]="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="chiusaOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div>
          <div class="flex w-full align-items-center w-8 gap-4">
            <p class="w-3">Delibera Finalizzata</p>
            <p-checkbox
              formControlName="finalizzata"
              [binary]="true"
              placeholder="--"
              class="w-6" />
            <p-dropdown
              formControlName="finalizzataOperator"
              class="operator"
              [options]="operatorDropdown" />
          </div> -->
        </div>
      }
      @if(showColumnSelect){
        <p-pickList
          [source]="sourceColumns"
          [target]="targetColumns"
          sourceHeader="Lista Colonne"
          targetHeader="Colonne Selezionate"
          [dragdrop]="true"
          [responsive]="true"
          breakpoint="1400px"
          [sourceStyle]="{ height: '22.5rem' }"
          [targetStyle]="{ height: '22.5rem' }">
          <ng-template let-column pTemplate="item">
            {{ column.nome }}
          </ng-template>
        </p-pickList>
      }
      <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">
        <p-paginator
          [first]="first"
          [rows]="pageSize"
          [rowsPerPageOptions]="[25, 100, 250, 500]"
          (onPageChange)="pageChange($event)"
          [totalRecords]="totaleDati"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}"
          [showPageLinks]="false" />
      </div>
    </form>
    <p-table
      #dt
      [value]="listaIscritti"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
      [sortField]="orderColumn"
      [sortOrder]="orderCustom(order)"
      class="pb-6">
      <ng-template pTemplate="header">
        <tr>
          @for(item of vociTabella; track $index){
            <th [pSortableColumn]="item.valore">
              {{ item.nome }}
              <p-sortIcon [field]="item.valore"></p-sortIcon>
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-iscritto>
        <tr>
          @for(item of vociTabella; track $index){
            @if(item.valore == 'statoIscritto'){
              <td class="font-bold" [style.color]="coloreStato(iscritto.statoIscritto)">
                {{ iscritto[item.valore] }}
              </td>
            }
            @else if(item.valore == 'situazione'){
              <td class="font-bold" [style.color]="coloreSituazione(iscritto.situazione)">
                {{ getSituazioneLabel(iscritto[item.valore]) }}
              </td>
            }
            @else{
              <td>{{ iscritto[item.valore] }}</td>
            }
          }
        </tr>
      </ng-template>
    </p-table>
    <p-toast position="bottom-center"></p-toast>
  }
</div>